<template>
  <div class="page-container">
    <div class="page-header">
      <div>
        <h2 class="page-title">菜单管理</h2>
      </div>
      <div class="page-header-extra">
        <span>一级 <b>{{ flatCount.lv1 }}</b></span>
        <span class="divider">|</span>
        <span>二级 <b>{{ flatCount.lv2 }}</b></span>
      </div>
    </div>

    <el-card class="search-card" shadow="never">
      <div class="search-bar">
        <el-form :inline="true" :model="query" size="small" class="search-form">
          <el-form-item label="菜单名称">
            <el-input v-model="query.keyword" placeholder="请输入菜单名称" clearable style="width: 180px" @keyup.enter.native="handleSearch" />
          </el-form-item>
          <el-form-item label="菜单级别">
            <el-select v-model="query.type" placeholder="全部" clearable style="width: 120px">
              <el-option label="一级菜单" :value="1" />
              <el-option label="二级菜单" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="query.status" placeholder="全部" clearable style="width: 110px">
              <el-option label="显示" :value="1" />
              <el-option label="隐藏" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="action-bar">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增菜单</el-button>
          <el-button size="small" @click="expandAll = !expandAll">{{ expandAll ? '全部收起' : '全部展开' }}</el-button>
        </div>
      </div>
    </el-card>

    <el-card class="table-card" shadow="never">
      <el-table
        v-if="tableKey"
        v-loading="loading"
        :key="expandAll ? 'open' : 'close'"
        :data="menuTree"
        row-key="id"
        border
        size="small"
        :tree-props="{ children: 'children' }"
        :default-expand-all="expandAll"
        height="100%"
      >
        <el-table-column prop="name" label="菜单名称" min-width="180">
          <template slot-scope="scope">
            <i :class="scope.row.icon" style="margin-right:6px;color:var(--primary)"></i>{{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="级别" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 1 ? 'primary' : 'info'" size="mini" effect="plain">
              {{ scope.row.type === 1 ? '一级' : '二级' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="path" label="路由路径" min-width="180" show-overflow-tooltip/>
        <el-table-column prop="sort" label="排序" width="70" align="center"/>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini" effect="plain">
              {{ scope.row.status === 1 ? '显示' : '隐藏' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.type === 1"
              type="text"
              size="mini"
              @click="handleAddChild(scope.row)"
            >加二级</el-button>
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" class="text-danger-btn" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? '编辑菜单' : '新增菜单'" :visible.sync="dialogVisible" width="720px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="菜单级别">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">一级菜单</el-radio>
            <el-radio :label="2">二级菜单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.type === 2" label="上级菜单" prop="parent_id">
          <el-select v-model="form.parent_id" style="width: 100%">
            <el-option v-for="m in parentOptions" :key="m.id" :label="m.name" :value="m.id" />
          </el-select>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="菜单名称" prop="name">
              <el-input v-model="form.name" maxlength="64" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图标">
              <el-input v-model="form.icon" placeholder="如 el-icon-menu" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="路由路径" prop="path">
          <el-input v-model="form.path" placeholder="如 /system/company" />
        </el-form-item>
        <el-form-item v-if="form.type === 2" label="组件路径">
          <el-input v-model="form.component" placeholder="如 system/company/index" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="999" controls-position="right" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="显示" inactive-text="隐藏" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMenus, getMenuTree, addMenu, updateMenu, deleteMenu } from '@/api/system'

const emptyForm = () => ({
  id: 0, parent_id: undefined, name: '', type: 1, icon: '', path: '', component: '', sort: 1, status: 1
})

// 把树摊平成一级/二级计数（顶部统计）
function countLevels(tree) {
  let lv1 = 0
  let lv2 = 0
  const walk = (arr) => {
    (arr || []).forEach((n) => {
      if (n.type === 1) lv1 += 1
      else lv2 += 1
      if (n.children && n.children.length) walk(n.children)
    })
  }
  walk(tree)
  return { lv1, lv2 }
}

export default {
  name: 'MenuManage',
  data() {
    return {
      loading: false,
      menuTree: [],
      query: { keyword: '', type: '', status: '' },
      dialogVisible: false,
      form: emptyForm(),
      expandAll: true,
      tableKey: true,
      parentOptions: [],
      rules: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        path: [{ required: true, message: '请输入路由路径', trigger: 'blur' }]
      }
    }
  },
  computed: {
    flatCount() {
      return countLevels(this.menuTree)
    }
  },
  watch: {
    expandAll() {
      // 切换展开状态时强制重建表格，触发展开状态生效
      this.tableKey = false
      this.$nextTick(() => { this.tableKey = true })
    }
  },
  created() {
    this.loadData()
    this.loadParentOptions()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getMenus(this.query)
        if (res.code === 200) {
          this.menuTree = (res.data && res.data.list) || []
        }
      } finally {
        this.loading = false
      }
    },
    async loadParentOptions() {
      try {
        const res = await getMenuTree()
        // tree 接口返回纯数组（全量显示中菜单），取一级菜单作「上级菜单」下拉
        if (res.code === 200) {
          this.parentOptions = (res.data || []).filter((m) => m.type === 1)
        }
      } catch (e) {
        // 下拉拉取失败不影响列表，下次打开弹窗时已在 created 加载
      }
    },
    handleSearch() {
      this.loadData()
    },
    resetSearch() {
      this.query = { keyword: '', type: '', status: '' }
      this.loadData()
    },
    handleAdd() {
      this.form = emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleAddChild(row) {
      // 预填：二级 + 上级=当前一级菜单（row 仅取 id，不把整行带进表单）
      this.form = Object.assign(emptyForm(), { type: 2, parent_id: row.id })
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleEdit(row) {
      // 编辑回显：用空表单兜底，避免 row.children 等无关字段污染提交体
      this.form = Object.assign(emptyForm(), row)
      delete this.form.children
      // parent_id=0（顶级菜单）不渲染成 "0"，显示 placeholder
      if (!this.form.parent_id) this.form.parent_id = undefined
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleDelete(row) {
      const children = (row.children || []).length
      const tip = children
        ? `该菜单下有 ${children} 个二级菜单，将一并删除。确认删除「${row.name}」？`
        : `确认删除菜单「${row.name}」？`
      this.$confirm(tip, '删除确认', { type: 'warning' }).then(async () => {
        try {
          const res = await deleteMenu(row.id)
          if (res.code !== 200) return // 拦截器已弹失败原因
          this.$message.success('已删除')
          this.loadData()
          this.loadParentOptions()
        } catch (e) {
          // 网络层错误拦截器已弹，无需重复提示
        }
      }).catch(() => {})
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        // 显式提取白名单字段，避免把 id/children/perms 等误传（守「隐藏≠清值」）
        const payload = {
          type: this.form.type,
          name: this.form.name,
          icon: this.form.icon,
          path: this.form.path,
          sort: this.form.sort,
          status: this.form.status
        }
        if (this.form.type === 2) {
          payload.parent_id = this.form.parent_id
          payload.component = this.form.component
        }

        try {
          const res = this.form.id
            ? await updateMenu(this.form.id, payload)
            : await addMenu(payload)
          if (res.code !== 200) return // 拦截器已弹失败原因（如「仅超管可改」「上级不能选自己」）
          this.$message.success(this.form.id ? '已保存修改' : '新增成功')
          this.dialogVisible = false
          this.loadData()
          this.loadParentOptions()
        } catch (e) {
          // 网络层错误拦截器已弹
        }
      })
    }
  }
}
</script>
